var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useEffect, } from 'react';
import FilePreview from './file-preview';
import InputWrapper from './input-wrapper';
var Input = forwardRef(function Input(_a, ref) {
    var afterLabel = _a.afterLabel, children = _a.children, className = _a.className, helpText = _a.helpText, hideLabel = _a.hideLabel, id = _a.id, label = _a.label, required = _a.required, errorMessage = _a.errorMessage, inputGroupTextBefore = _a.inputGroupTextBefore, inputGroupTextAfter = _a.inputGroupTextAfter, preview = _a.preview, props = __rest(_a, ["afterLabel", "children", "className", "helpText", "hideLabel", "id", "label", "required", "errorMessage", "inputGroupTextBefore", "inputGroupTextAfter", "preview"]);
    useEffect(function () {
        var handleWheel = function (e) {
            e.preventDefault();
        };
        if (props.type === 'number') {
            var el_1 = document.getElementById(id);
            el_1 === null || el_1 === void 0 ? void 0 : el_1.addEventListener('wheel', handleWheel, { passive: false });
            return function () {
                el_1 === null || el_1 === void 0 ? void 0 : el_1.removeEventListener('wheel', handleWheel);
            };
        }
    }, []);
    useEffect(function () {
        var el = document.getElementById(id);
        if (el) {
            el.setCustomValidity(errorMessage || '');
        }
    }, [id, errorMessage]);
    return (_jsxs(_Fragment, { children: [_jsx(InputWrapper, { afterLabel: afterLabel, className: className, required: required, label: label, id: id, helpText: helpText, hideLabel: hideLabel, children: _jsxs("div", { className: "input-group", children: [inputGroupTextBefore && (_jsx("span", { className: "input-group-text", children: inputGroupTextBefore })), _jsx("input", __assign({ min: props.type === 'date' ? '1900-01-01' : undefined }, props, { required: required, className: "form-control ".concat(errorMessage ? 'is-invalid' : ''), "aria-invalid": errorMessage ? 'true' : 'false', id: id, ref: ref })), inputGroupTextAfter && (_jsx("div", { className: "input-group-text", children: inputGroupTextAfter })), errorMessage && (_jsx("div", { className: "invalid-feedback", children: errorMessage })), children] }) }), _jsx(FilePreview, { file: preview })] }));
});
export default Input;
